import React from 'react'
import { ButtonWithLoading } from '../button-with-loading/ButtonWithLoading'
import { ATLButton } from '@appsimples/atlantica-react-native'
import { atlTheme } from '../../atlTheme'
import { loginButtonRadius } from '../../constants/dimensions'

interface LoadingButtonProps {
  isLoading: boolean
  onSubmit: () => void
  title: string
  horizontalMargin: number
}

export const LoadingButton: React.FunctionComponent<LoadingButtonProps> = ({
  isLoading,
  onSubmit,
  title,
  horizontalMargin,
}) => {
  return isLoading ? (
    <ButtonWithLoading />
  ) : (
    <ATLButton
      horizontalMargin={horizontalMargin}
      title={title}
      buttonBaseProps={{ buttonColor: atlTheme.ColorBrand1Default, borderRadius: loginButtonRadius }}
      onPress={onSubmit}
    />
  )
}
